import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

// local imports
import { saveAsExcelFile } from 'utils/Miscellaneous'
import ExportBtn from './ExportBtn'

interface CompProps {
  children: ReactNode
  excelData: any
}

export default function GymServiceDist({ excelData, children }: CompProps) {
  const { t } = useTranslation()

  const handleExport = () => {
    import('xlsx').then((xlsx) => {
      let heading = [
        [
          t('most-used-words.firm'),
          t('dashboard.on-campus-tabs.personal'),
          t('dashboard.on-campus-tabs.group-lesson'),
          t('dashboard.on-campus-tabs.trainer'),
          t('dashboard.num-of-all-notification'),
        ],
      ]

      const totalCount = excelData?.map((res: any) => res.totalCount)[0]
      const arr = excelData?.map((res: any) => {
        const { FirmName, personal, group, trainer } = res || {}
        return { FirmName, personal, group, trainer, totalCount: personal + group + trainer }
      })

      const totalRow = arr.reduce(
        (acc: any, curr: any) => {
          acc.personal += curr.personal || 0
          acc.group += curr.group || 0
          acc.trainer += curr.trainer || 0
          acc.totalCount = totalCount || 0
          return acc
        },
        {
          FirmName: '',
          personal: 0,
          group: 0,
          trainer: 0,
          totalCount: 0,
        }
      )

      const totalHeading = {
        FirmName: '',
        personal: t('dashboard.on-campus-tabs.personal'),
        group: t('dashboard.on-campus-tabs.group-lesson'),
        trainer: t('dashboard.on-campus-tabs.trainer'),
        totalCount: t('dashboard.on-campus-tabs.gym-all-detail-msg'),
      }

      arr.push(...[{}, totalHeading, totalRow])

      /* header */
      const ws = xlsx.utils.book_new()
      xlsx.utils.sheet_add_aoa(ws, heading)
      const worksheet = xlsx.utils.sheet_add_json(ws, arr!, { origin: 'A2', skipHeader: true })
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] }
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' })
      saveAsExcelFile(excelBuffer, t('dashboard.on-campus-tabs.gym-res'))
    })
  }

  return (
    <>
      {!!excelData && excelData?.length ? <ExportBtn handleExport={handleExport} /> : null}
      {children}
    </>
  )
}
